export const UPDATE_ENTRIES_STATE = "UPDATE_ENTRIES_STATE"
export const UPDATE_ENTRIES_HISTORY = "UPDATE_ENTRIES_HISTORY"
export const UPDATE_ALL_ENTRIES = "UPDATE_ALL_ENTRIES"
